import React from "react";
import Dashboard from "../Components/Dashboard/Dashboard";

const DashboardPage = () => {
  return (
    <div>
      <Dashboard />
    </div>
  );
};

export default DashboardPage;
